<div [class]="isModal ? 'modal-content' : 'main-content'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div>
          <!-- Header for Modal -->
          <div *ngIf="isModal"
            style="display: flex; justify-content: space-between; align-items: center; padding: 10px;">
            <h4 class="card-title">Ledger Book</h4>
            <button mat-icon-button (click)="closeModal()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <div class="filter-row">
            <mat-form-field appearance="outline">
              <mat-label>From Date</mat-label>
              <input matInput type="date" [(ngModel)]="startdate" [min]="minDate" [max]="maxDate">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>To Date</mat-label>
              <input matInput type="date" [(ngModel)]="enddate" [min]="minDate" [max]="maxDate">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Select Branch</mat-label>
              <mat-select [(ngModel)]="branchId" (ngModelChange)="onBranchChange($event)">
                <mat-option [value]="null">All</mat-option>
                <mat-option *ngFor="let branch of branches" [value]="branch.id">
                  {{ branch.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

              <mat-form-field appearance="outline">
              <mat-label>Select Profit Cost</mat-label>
              <mat-select [(ngModel)]="profitcost"  (ngModelChange)="onProfitCostChange($event)">
                <mat-option [value]="null">All</mat-option>
                <mat-option *ngFor="let profitcost of profitCost_data" [value]="profitcost.id">
                  {{ profitcost.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>


              <mat-form-field appearance="outline">
              <mat-label>Select Section</mat-label>
              <mat-select [(ngModel)]="section">
                <mat-option [value]="null">All</mat-option>
                <mat-option *ngFor="let item of section_data" [value]="item.id">
                  {{ item.section_name  }}
                </mat-option>
              </mat-select>
            </mat-form-field>


              <mat-form-field appearance="outline">
              <mat-label>Select Store</mat-label>
              <mat-select [(ngModel)]="store">
                <mat-option [value]="null">All</mat-option>
                <mat-option *ngFor="let item of store_data" [value]="item.id">
                  {{ item.store_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <button mat-raised-button color="primary" class="search-button" (click)="onSearch()">
              Search
            </button>

            <button mat-raised-button color="accent" class="reset-button" (click)="resetFilters()">
              Reset
            </button>

            <div class="export-button">
              <div class="dropdown">
                <button class="btn btn-primary dropdown-toggle" type="button" id="exportDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Export
                </button>
                <div class="dropdown-menu" aria-labelledby="exportDropdown">
                  <a class="dropdown-item" (click)="exportToExcel()">Export to Excel</a>
                  <a class="dropdown-item" (click)="convertToPdf()">Export to PDF</a>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" *ngIf="!isModal">
              <h4 class="card-title">Ledger Name</h4>
              <p class="card-category"></p>
            </div>
            <div class="card-body table-responsive">
              <cdk-virtual-scroll-viewport #virtualScrollViewport itemSize="80" class="scroll-box"
                (scrolledIndexChange)="onScrollIndexChange($event)" [style.height]="isModal ? '60vh' : '500px'">

                <table class="table">
                  <thead>
                    <tr>
                      <th (click)="sortData('ledger_name')" class="sortable-column">
                        Ledger Name
                        <mat-icon class="sort-icon">
                          {{ getSortDirection('ledger_name') === 'asc' ? 'arrow_upward' : (getSortDirection('ledger_name') === 'desc' ? 'arrow_downward' : 'unfold_more') }}
                        </mat-icon>
                      </th>
                      <th>Branch</th>
                      <th class="right-align">Opening Balance</th>
                      <th class="right-align">Dr Amount</th>
                      <th class="right-align">Cr Amount</th>
                      <th class="right-align">Closing Balance</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *cdkVirtualFor="let item of ledgerData; let i = index; trackBy: trackByFn">
                      <tr class="ledger-row">
                        <td>
                          <input type="checkbox" [checked]="selectedLedgers.includes(item.id)" (change)="toggleSelection(item.id, $event)" />
                          <button mat-icon-button (click)="toggleRow(item)" class="expand-button">
                            <mat-icon>{{ selectedItem && selectedItem === item.id ? 'keyboard_arrow_up' : 'keyboard_arrow_right' }}</mat-icon>
                          </button>
                          <!-- {{ item.ledger_name }} -->
                            <span class="ledger-link" (click)="openVoucherBreakdown(item)">
                              {{ item.ledger_name }}
                            </span>
                        </td>
                        <!-- <td>{{ getBranchDisplayName(item) }}</td> -->
                         <td>{{ item.branch_name }}</td>
                        <td class="right-align">
                          <!-- {{ calculateOpeningBalanceAndSide(item).balance | number: '1.2-2' }} {{ calculateOpeningBalanceAndSide(item).side }} -->
                            {{ item.opening_balance }} {{ item.opening_balance_side }}
                        </td>
                        <td class="right-align">{{ item.total_dr_amount | number: '1.2-2' }} Dr</td>
                        <td class="right-align">{{ item.total_cr_amount | number: '1.2-2'}} Cr</td>
                        <!-- <td class="right-align">{{ calculateClosingBalanceAndSide(item)}}</td> -->
                        <td class="right-align">
                          <span class="ledger-link" (click)="openVoucherBreakdown(item)">
                            {{ calculateClosingBalanceAndSide(item) }}
                          </span>
                        </td>

                        <td>
                          <button mat-icon-button matTooltip="Open Statement View"
                            (click)="openStatementViewModal(item.id)">
                            <mat-icon>description</mat-icon>
                          </button>
                        </td>
                      </tr>
                      <tr *ngIf="selectedItem && (selectedItem == (item.ledger_id || item.id))"
                        class="voucher-details-row">
                        <td colspan="7" class="voucher-details-container">
                          <h4>Voucher Details</h4>
                          <div class="voucher-details-scroll-container">
                            <table class="second-table">
                              <thead>
                                <tr>
                                  <th rowspan="2"></th>
                                  <th rowspan="2">Date</th>
                                  <th rowspan="2">Voucher Type</th>
                                  <th rowspan="2">Voucher No</th>
                                  <th rowspan="2">Dr. Amount</th>
                                  <th rowspan="2">Cr. Amount</th>
                                  <th colspan="2">Particular</th> 
                                </tr>
                                <tr>
                                  <th>Ledger Name</th>
                                  <th>Amount</th>       
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngIf="voucherpostingdata && voucherpostingdata.length > 0; else noDataTemplate">
                                  <ng-container *ngFor="let voucher of voucherpostingdata; let i = index">
                                    <tr (click)="toggleNestedTables(voucher)" class="voucher-row">
                                      <td>
                                        <button mat-icon-button>
                                          <mat-icon>{{ isNestedItemExpanded(voucher) ? 'keyboard_arrow_up' : 'keyboard_arrow_right' }}</mat-icon>
                                        </button>
                                      </td>
                                      <td>{{ voucher.date }}</td>
                                      <td>{{ voucher.voucher_name }}</td>
                                      <td>{{ voucher.voucher_no }}</td>
                                      <td>{{ voucher.total_dr }}</td>
                                      <td>{{ voucher.total_cr }}</td>
                                      <td>
                                        <span *ngIf="voucher.particular?.ledger_name">{{ voucher.particular.ledger_name }}</span>
                                      </td>
                                      <td>
                                        <span *ngIf="voucher.particular?.amount">{{ voucher.particular.amount }}</span>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </ng-container>
                                <ng-template #noDataTemplate>
                                  <tr>
                                    <td colspan="8"><center>No data found</center></td>
                                  </tr>
                                </ng-template>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                    <tr *ngIf="loading" class="loading-row">
                      <td colspan="7">
                        <div class="loading-container">
                          <div *ngFor="let item of [1, 2, 3, 4, 5, 6]" class="skeleton-row"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary fetch-all" (click)="fetchAllData()" [disabled]="loading">
                {{ loading ? 'Loading...' : 'Fetch All' }}
              </button>
              <span class="data-info">
                Showing {{ ledgerData.length }} items {{ hasMore ? '(scroll for more)' : '' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>